/**
 * Stateless aggregate-edit preview. The caller owns the immutable basis and
 * pending intent history; this hook only transports the generated BFF contract.
 */
import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import { previewAggregateEdit } from '@ebalance/proto/bffuser/v1/demand_forecast_service-DemandForecastService_connectquery'
import {
  PreviewAggregateEditRequestSchema,
  PreviewAggregateEditResponseSchema,
} from '@ebalance/proto/bffuser/v1/demand_forecast_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

export function usePreviewAggregateEdit(): UseMutationResult<
  MessageShape<typeof PreviewAggregateEditResponseSchema>,
  ConnectError,
  MessageInitShape<typeof PreviewAggregateEditRequestSchema>
> {
  return useMutation(previewAggregateEdit)
}
